<template>
  <asc-dialog
    :show-dialog="showDialog"
    :text="getAnalyticName"
    :on-close="handleClose"
    :on-primary="
      data && data.overRideDefaultMxRecDetails
        ? handleAnalyticDetailsSave
        : undefined
    "
    :primary-available="
      !saving && isApplyBtnAvailable && customEntries !== savedCustomEntry
    "
    :width="1000"
    show-actions-border
    full-width-buttons
    primary-button-text="Save"
  >
    <div v-if="data" class="asc-mx-analytic-details-wrapper">
      <asc-card flat outlined no-spacing class="mb-4">
        <v-container class="analytic-details-container">
          <v-row>
            <v-col class="asc-card--title">ANALYTIC DETAILS</v-col>
          </v-row>
          <v-row>
            <v-col sm="2" cols="12">
              <label>Airline</label>
              <div>{{ data.airlineName }}</div>
            </v-col>
            <v-col sm="2" cols="12">
              <label>Platform</label>
              <div>{{ data.platform }}</div>
            </v-col>
            <v-col sm="2" cols="12">
              <label>ATA Chapter</label>
              <div>{{ data.ataChapter }}</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <label>Analytic Description</label>
              <div>{{ data.description }}</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div
                class="d-flex justify-center align-center pa-2"
                style="background-color: #f7f7f7"
              >
                <span v-if="data.isActive">
                  <v-icon left size="20" color="#50d264">mdi-check</v-icon>
                  <span>Activated</span>
                </span>
                <span v-else>
                  <v-icon left size="20" color="#d20532">mdi-close</v-icon>
                  <span>Inactive</span>
                </span>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </asc-card>

      <asc-card flat outlined no-spacing class="mb-4">
        <v-container>
          <v-row>
            <v-col class="asc-card--title">ALERTS</v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-container fluid class="alerts-grid-container pa-1">
                <v-row
                  v-for="(row, index) in data.alertTypes"
                  :key="index"
                  no-gutters
                >
                  <v-col>
                    {{ row.analyticName }}
                  </v-col>
                  <v-col>
                    {{ row.name }}
                  </v-col>
                  <v-col cols="2">
                    {{ row.component }}
                  </v-col>
                  <v-col v-if="row.isActive" cols="2">
                    <v-icon left size="20" color="#50d264">mdi-check</v-icon>
                    <span>Activated</span>
                  </v-col>
                  <v-col v-else cols="2">
                    <v-icon left size="20" color="#d20532">mdi-close</v-icon>
                    <span>Inactive</span>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </asc-card>

      <asc-card flat outlined no-spacing class="mb-4">
        <v-container class="mxrec-container">
          <v-row>
            <v-col class="asc-card--title">MAINTENANCE RECOMMENDATION</v-col>
          </v-row>
          <v-row>
            <v-col>DEFAULT ENTRY</v-col>
          </v-row>
          <v-row>
            <v-col class="pt-1">
              <v-container class="default-entries-container">
                <v-row>
                  <v-col style="padding-bottom: 0">
                    <label>Maintenance Recommendation Title</label>
                    <div>{{ data.defaultMxRecEntry.mxRecTitle }}</div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="content">
                    <label>Maintenance Recommendation</label>
                    <asc-rich-text-input
                      :comment="data.defaultMxRecEntry.mxRecDetails"
                      :can-edit="false"
                      :max-length="3500"
                      hidden-menu
                      hide-details
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
          <v-row v-if="data.overRideDefaultMxRecDetails">
            <v-col style="display: flex; align-items: center">
              <label>CUSTOM ENTRY</label>
              <asc-switch
                v-model="editCustomEntries"
                label=""
                single-line
                hide-details
                class="ml-2"
              />
            </v-col>
          </v-row>
          <v-row v-if="data.overRideDefaultMxRecDetails">
            <v-col class="pt-1">
              <v-container class="custom-entries-container">
                <label>Maintenance Recommendation</label>
                <asc-rich-text-input
                  :comment="savedCustomEntry"
                  :can-edit="editCustomEntries"
                  :max-length="3500"
                  :counter="true"
                  hidden-menu
                  @updated="handleUpdatedCustomEntry"
                />
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </asc-card>
    </div>
  </asc-dialog>
</template>

<script>
import AscDialog from '@/components/atoms/AscDialog'
import AscCard from '@/components/atoms/AscCard'
import AscRichTextInput from '@/components/atoms/AscRichTextInput'
import AscSwitch from '@/components/atoms/AscSwitch'

export default {
  name: 'AscAnalyticDetailsDialog',

  components: {
    AscDialog,
    AscCard,
    AscRichTextInput,
    AscSwitch,
  },

  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: null,
    },
    savedCustomEntry: {
      type: String,
      default: '',
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      editCustomEntries: false,
      customEntries: '',
    }
  },

  computed: {
    getAnalyticName() {
      return this.data?.name || ''
    },

    isApplyBtnAvailable() {
      return !!(
        this.data?.overRideDefaultMxRecDetails &&
        this.editCustomEntries &&
        this.customEntries.length
      )
    },
  },

  methods: {
    handleAnalyticDetailsSave() {
      this.$emit('onAnalyticDetailsSave', {
        analyticModuleId: this.data.id,
        airlineId: this.data.airlineId,
        customEntries: this.customEntries,
        platformName: this.data.platform,
      })
    },

    handleClose() {
      this.editCustomEntries = false
      this.customEntries = ''
      this.$emit('onAnalyticDetailsDialogClose')
    },

    handleUpdatedCustomEntry(text) {
      this.customEntries = text
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-mx-analytic-details-wrapper {
  padding-right: 4px;

  .asc-card {
    .asc-card--title {
      border-bottom: 1px solid $gray-300;
    }

    .analytic-details-container {
      label {
        font-weight: 400;
        color: $gray-700;
        display: block;
        margin-bottom: 4px;
      }
    }

    .alerts-grid-container {
      .row {
        border-top: 1px solid $gray-300;

        &:last-child {
          border-bottom: 1px solid $gray-300;
        }

        .col {
          border-left: 1px solid $gray-300;
          padding: 8px 10px;

          &:last-child {
            border-right: 1px solid $gray-300;
          }
        }
      }
    }

    .default-entries-container,
    .custom-entries-container {
      border: 1px solid $gray-300;

      label {
        color: $gray-600;
        font-size: 12px;
        margin-bottom: 4px;
      }

      .content {
        line-height: 22px;
      }
    }
  }
}
</style>
